<script setup>
import Video from '../default/Video.vue'

defineProps({
  item: Object,
})

const { onDisappear } = useDisappearable()

const videoElement = ref(null)

onMounted(() => {
  gsap.timeline().from(videoElement.value, { opacity: 0, duration: 1 }, '<.5').to(videoElement.value, { opacity: 1, duration: 1 })
})

onDisappear(async () => {
  await gsap.to(videoElement.value, { opacity: 0, duration: 0.8 })
})
</script>

<template>
  <Video ref="videoElement" :item="item" />
</template>
